<script setup>
import BaseGeneralDetails from '@/components/common/details/BaseGeneralDetails.vue';
import BaseRowDetails from '@/components/common/details/BaseRowDetails.vue';
import BaseGridDetails from '@/components/common/details/BaseGridDetails.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps(['detailedItem']);
const pobox = props.detailedItem;

const setTotalsDetails = () => {
    return {
        title: 'Totals',
        data: [
            {
                label: 'Invoices',
                value: `${pobox.invoicebalance ? pobox.invoicebalance : '0.00'}`
            },
            {
                label: 'Multipays',
                value: `${pobox.multipaybalance ? pobox.multipaybalance : '0.00'}`
            },
            {
                label: 'Debit Credit',
                value: `${pobox.creditbalance ? pobox.creditbalance : '0.00'}`
            },
            {
                label: 'Balance Due',
                value: `${pobox.globalbalance ? pobox.globalbalance : '0.00'}`
            }
        ]
    };
};

const setAddressTitle = () => {
    return {
        title: 'Pobox Address',
        icon: 'mdi-mailbox'
    };
};

const setAddressDetail = () => {
    return {
        data: [
            {
                label: t(
                    'To send online purchases, commercial shipments, or packages:'
                ),
                value: `${pobox.customer.fullName} - ${pobox.agency.name} - ${pobox.customer.number}`
            },
            {
                label: t('To any of these addresses:'),
                value: `${pobox.agencyAddress ?? ''} ${pobox.agencyAddress2 ?? ''}`
            }
        ]
    };
};
</script>

<template>
    <BaseRowDetails
        v-if="pobox.adrdefault"
        :item="setAddressDetail()"
    ></BaseRowDetails>

    <v-divider v-if="pobox.adrdefault" class="my-3"></v-divider>

    <v-divider class="my-3"></v-divider>

    <BaseGeneralDetails :item="setAddressTitle()"></BaseGeneralDetails>
    <v-alert
        color="white"
        density="compact"
        class="text-black"
    >
        <template #default>
            <div>
                <strong class="text-h6">{{ setAddressDetail().title }}</strong>
                <div
                    v-for="(item, index) in setAddressDetail().data"
                    :key="index"
                    class="mt-3"
                >
                    <div class="text-caption text-grey-darken-1 mb-1">
                        <h3>{{ item.label }}</h3>
                    </div>
                    <div class="text-body-2">
                        {{ item.value }}
                    </div>
                </div>
            </div>
        </template>
    </v-alert>

    <v-divider class="my-3"></v-divider>
    <BaseGridDetails :grids="setTotalsDetails()"></BaseGridDetails>
</template>
